import { render } from "./VInput.vue?vue&type=template&id=4bdf5884&scoped=true"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"

import "./VInput.vue?vue&type=style&index=0&id=4bdf5884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdf5884"]])

export default __exports__